export enum ScreenRenderMode {
  Static = "STATIC",
  Lazy = "LAZY"
}
